import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ModalLayoutRightComponent } from 'projects/app-default/src/app/ui/modal/modal-layout-right.component';
import { CmsSpecificationSectionItemComponent } from '../item/cms-specification-section-item.component';

export namespace NSpecificationSectionModal {
    export const specificationSectionModalId = 'specification-section-modal';

    export interface IInitiatorData {
        sections?: number[];
    }
}
@DfModal({
    id: NSpecificationSectionModal.specificationSectionModalId,
    position: 'right',
    config: sizeName => ({
        width: { S: '100vw', M: '100vw', L: '30.75rem', X: '30.75rem' }[sizeName],
        height: '100vh',
        position: {
            top: '0',
            right: '0',
            bottom: '0'
        },
        maxWidth: '100vw'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    prerenderAllowed: false,
    sizeRestriction: sizeName => ({ S: ['S', 'M'], M: ['S', 'M'], L: ['L', 'X'], X: ['L', 'X'] })[sizeName]
})
@Component({
    selector: 'specification-section-modal',
    templateUrl: './specification-section-modal.html',
    standalone: true,
    imports: [ModalLayoutRightComponent, TranslationModule, NgClass, CmsSpecificationSectionItemComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpecificationSectionModalComponent {
    constructor(
        private modalRef: ModalRef<SpecificationSectionModalComponent>,
        @Inject(MODAL_DATA) public data: NSpecificationSectionModal.IInitiatorData
    ) {}

    protected close(): void {
        this.modalRef.close();
    }
}
